import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const OrganizationSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
OrganizationSettingsViewTopBar.displayName = "OrganizationSettingsViewTopBar"
